module.exports = __webpack_public_path__ + "static/media/warning.32263930.svg";